export function sanitizeInput(value: unknown) {
  const text = value as string;
  if (!text) {
    return text;
  }

  // Remove all non-printable characters (ASCII codes 0-31), except from TAB(0009), line feed(000A) and carriage return(000D).
  return text.toString().replace(/[\u0000-\u0008\u000B-\u000C\u000E-\u001F]/gm, '');
}
